import styled from 'styled-components';
import { ReactComponent as TickCircle } from '../../assets/img/icons/green-filled-tick.svg';
import FormHandler from '../../assets/img/form-handler.png';
import GlobalCustomButton from 'modules/Common/Components/GlobalCustomButton';
import { useHistory } from 'react-router-dom';
import AddIcon from 'assets/svgs/AddIcon';
import { FORM_HANDLER_USER_GUIDE } from './Forms/constants';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const LeftSection = styled.div`
  .button {
    margin-top: 24px;
  }
  .global-custom-btn-style {
    font-size: 14px !important;
  }
`;
const RightSection = styled.div`
  padding-left: 40px;
  @media all and (max-width: 1280px) and (max-height: 729px) {
    img {
      height: 350px !important;
    }
  }
`;
const Title = styled.div`
  font-family: 'Roboto Slab';
  font-size: 26px;
  font-weight: 700;
  line-height: 39px;
  @media all and (max-width: 1280px) and (max-height: 729px) {
    font-size: 20px !important;
    line-height: 32px !important;
  }
`;
const Description = styled.div`
  font-family: 'Roboto';
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  max-width: 520px;
  @media all and (max-width: 1280px) and (max-height: 729px) {
    font-size: 16px !important;
    line-height: 20px !important;
  }
`;
const ListSection = styled.div`
  display: flex;
  flex-direction: column;
  .list-styling {
    display: flex;
    // align-items: center;
    margin-top: 12px;
    @media all and (max-width: 1280px) and (max-height: 729px) {
      margin-top: 4px !important;
    }
  }
  margin-top: 12px;
  @media all and (max-width: 1280px) and (max-height: 729px) {
    margin-top: 12px !important;
  }
`;
const ListTitle = styled.div`
  color: #424b50;
  font-family: 'Roboto';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin-left: 8px;
  max-width: 513px;
  @media all and (max-width: 1280px) and (max-height: 729px) {
    font-size: 14px !important;
  }
  span {
    color: #424b50;
    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    @media all and (max-width: 1280px) and (max-height: 729px) {
      font-size: 13px !important;
    }
  }
  .link-text {
    color: #1ec252;
    font-family: 'Roboto';
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    text-decoration-line: underline;
    cursor: pointer;
    @media all and (max-width: 1280px) and (max-height: 729px) {
      font-size: 13px !important;
    }
  }
`;
const FormsDefaultPage: React.FC = () => {
  const history = useHistory();
  const listItems = [
    { title: 'Lead Capture: ', description: 'Connect your web forms to xiQ Workbench effortlessly.', guideOption: false },
    { title: 'Automate Data Flow: ', description: 'Data from form submissions is sent directly to your xiQ Workbench account.', guideOption: false },
    {
      title: 'Campaign Attribution: ',
      description: 'Easily attribute leads to specific marketing campaigns for accurate tracking.',
      guideOption: false,
    },
    { title: 'Customize Form Mapping: ', description: 'Map form fields to match your integration requirements.', guideOption: false },
    { title: 'Create and Manage: ', description: 'Form Handlers with an intuitive interface. ', guideOption: true },
  ];
  return (
    <Wrapper>
      <LeftSection>
        <Title>Turn Visitors into valuable leads</Title>
        <Description>
          Seamlessly integrate external forms with xiQ Workbench. Capture valuable data, track leads, and automate your marketing efforts with ease.
        </Description>
        {/* List */}
        <ListSection>
          {listItems.map((item, index) => (
            <div className="list-styling" key={index}>
              <span>
                <TickCircle />
              </span>
              <ListTitle>
                {item.title} <span>{item.description}</span>
                {item.guideOption && (
                  <span className="link-text">
                    <a href={FORM_HANDLER_USER_GUIDE} target="_blank">
                      view guide
                    </a>
                  </span>
                )}
              </ListTitle>
            </div>
          ))}
        </ListSection>
        <div className="button">
          <GlobalCustomButton
            btnText={'Create New Form Handler'}
            disabled={false}
            onClick={() => history.push('/settings/forms/create_form')}
            border={'none'}
            padding={''}
            bgColor={'#1EC252'}
            color={'#fff'}
            customIcon={<AddIcon />}
            borderRadius={'6px'}
            fontSize={'16px'}
            boxShadow={''}
            width="auto"
          />
        </div>
      </LeftSection>
      <RightSection>
        <img src={FormHandler} alt="form-handler-img" />
      </RightSection>
    </Wrapper>
  );
};

export default FormsDefaultPage;
